import { render, staticRenderFns } from "./staffPagination.vue?vue&type=template&id=dc012a3c"
import script from "./staffPagination.vue?vue&type=script&lang=js"
export * from "./staffPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports